"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseContract = exports.PaginatedHearings = exports.GetHearingsForCaseQueryParams = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const refine_1 = require("./util/refine");
const c = (0, core_1.initContract)();
const GetHearingsForCaseQueryParamsSchema = resources_1.PaginationQueryParamsSchema.merge(resources_1.SortDirectionQueryParamsSchema).merge(zod_1.default.object({
    courtSystemId: zod_1.default.string().uuid(),
}));
exports.GetHearingsForCaseQueryParams = GetHearingsForCaseQueryParamsSchema.refine((refine_1.is));
const PaginatedHearingsSchema = (0, resources_1.createPaginatedResponseSchema)(resources_1.Hearing);
exports.PaginatedHearings = PaginatedHearingsSchema.refine((refine_1.is));
const path = '/case';
exports.caseContract = c.router({
    getCase: {
        method: 'GET',
        path: `${path}/:caseId`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: resources_1.Case,
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
            [404]: null,
        },
        query: zod_1.default.object({ courtSystemId: zod_1.default.string().uuid() }),
        pathParams: zod_1.default.object({ caseId: zod_1.default.string().uuid() }),
        summary: 'Retrieve a single case for a court system',
    },
    getHearingsForCase: {
        method: 'GET',
        path: `${path}/:caseId/hearings`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: exports.PaginatedHearings,
            [400]: resources_1.ErrorResponse,
            [401]: resources_1.ErrorResponse,
            [403]: resources_1.ErrorResponse,
            [404]: null,
        },
        query: exports.GetHearingsForCaseQueryParams,
        pathParams: zod_1.default.object({ caseId: zod_1.default.string().uuid() }),
        summary: 'Retrieve hearings for a case in a court system',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
});
